import { render } from "./Slider.vue?vue&type=template&id=de485c2a"
import script from "./Slider.vue?vue&type=script&lang=js"
export * from "./Slider.vue?vue&type=script&lang=js"
script.render = render

export default script